import { Client } from 'appwrite';
import { APPWRITE_SERVER } from '../constants/constants';

const client = new Client();

client.setEndpoint(APPWRITE_SERVER).setProject('eggies');

export default client;
